import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { Toaster } from './components/ui/sonner';

// Catch any unhandled errors and display them
window.addEventListener('error', (e) => {
  const root = document.getElementById('root');
  if (root && !root.hasChildNodes()) {
    root.innerHTML = '<div style="padding:4rem 2rem;text-align:center;color:#ff3333;font-family:monospace"><p>Error: ' + (e.message || 'Unknown error') + '</p><a href="/" style="color:#00ffd5">Reload</a></div>';
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster />
    </BrowserRouter>
  </React.StrictMode>
);
